import {SoopLoading} from '@soop-ui/soop-ui';
import styles from './SectionLoading.module.scss';

interface SectionLoadingProps {
  isMobile: boolean;
  pcHeight?: number;
}

const SectionLoading = ({isMobile, pcHeight}: SectionLoadingProps) => {
  return (
    <div className={styles.wrapper} style={{height: pcHeight}}>
      <SoopLoading isDevice={isMobile ? 'mobile' : 'desktop'} />
    </div>
  );
};

export default SectionLoading;
